import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet-async'
import { FaGlobe, FaPhone, FaEnvelope } from 'react-icons/fa'
import Modal from 'react-modal'

// Spinner Component
const Spinner = () => (
  <div className='flex items-center justify-center min-h-screen bg-black bg-opacity-90'>
    <div className='animate-spin rounded-full h-16 w-16 border-t-4 border-yellow-400 border-solid'></div>
  </div>
)

export default function Services ({ language }) {
  const [data, setData] = useState(null)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [selectedOption, setSelectedOption] = useState('')
  const [formData, setFormData] = useState({
    servicename: '',
    name: '',
    mobile: '',
    dob: '',
    birthplace: '',
    query: '',
    gender: ''
  })

  const [imageLoaded, setImageLoaded] = useState(false)
  const [errorMessage, setErrorMessage] = useState('');




  useEffect(() => {
    const img = new Image()
    img.src = '/image/bg/astroservice.webp' // Ensure correct path
    img.onload = () => setImageLoaded(true)
  }, [])

  useEffect(() => {
    fetch('/data.json')
      .then(response => response.json())
      .then(json => setData(json))
      .catch(error => console.error('Error loading data:', error))
  }, [])

  if (!data) {
    return <Spinner />
  }

  const openModal = () => setIsModalOpen(true)
  const closeModal = () => setIsModalOpen(false)

  const handleInputChange = e => {
    const { name, value } = e.target
    setFormData({ ...formData, [name]: value })
    setErrorMessage('');
  }

  const sendMessage = () => {

    const { servicename, name, mobile, dob, birthplace, query, gender } = formData;
  
  if (!servicename || !name || !mobile || !dob || !birthplace || !query || !gender) {
    setErrorMessage(language === "hindi" ? "कृपया सभी फ़ील्ड भरें।" : "Please fill in all fields.");
    return;
  }

    const message = `ServiceName:${formData.servicename}%0aName: ${formData.name}%0aMobile: ${formData.mobile}%0aDOB: ${formData.dob}%0aBirthplace: ${formData.birthplace}%0aQuery: ${formData.query}%0aGender: ${formData.gender}`
    const whatsappUrl = `https://wa.me/9827504751?text=${message}`
    window.open(whatsappUrl, '_blank')

    closeModal()
  }

  return (
    <div
      style={{
        backgroundImage: imageLoaded
          ? "url('/image/bg/astroservice.webp')"
          : 'none',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed',
        opacity: imageLoaded ? 1 : 0
      }}
    >
      <div className='md:p-6 p-5 bg-yellow-500 bg-opacity-80 min-h-screen mt-24 sm:mt-12'>
        <h1 className='text-4xl font-bold text-center text-black underline mt-24'>
          {data.servicesTitle[language]}
        </h1>  

        {/* Service Grid */}
        <div className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 mt-12 md:px-16 px-5 '>
          {data.services.map((service, index) => (
            <div
              key={index}
              className='bg-yellow-100 border border-black  text-black p-6 rounded-xl shadow-lg hover:shadow-2xl transition-transform transform hover:scale-105 flex flex-col justify-between min-h-[350px]'
            >
               <Helmet>
              <title>Services - AstroMahaMaya</title>
              <meta name="description" content={service.seodescription} />
              <meta name="keywords" content={service.keyword} />
              <meta property="og:title" content={service.title[language]} />
              <meta property="og:description" content="Discover personalized astrology services." />
              <meta property="og:url" content="https://astromahamaya.com/services" />
            </Helmet>
              {/* Service Image */}
              <div className='flex justify-center'>
                <img
                  src={`https://emojicdn.elk.sh/${service.image}`}
                  alt={service.title[language]}
                  className='w-24 h-24 rounded-full object-cover mb-4'
                />
              </div>

              {/* Service Title */}
              <h2 className='text-2xl font-bold text-black text-center '>
                {service.title[language]}
              </h2>

              {/* Price */}
              <p className='text-lg font-semibold text-center text-black mt-2'>
                {language === 'hindi'
                  ? `मूल्य: ${service.price}`
                  : `Price: ${service.price}`}
              </p>

              {/* Service Description */}
              <p className='mt-2 text-gray-700 text-center flex-grow'>
                {service.description[language]}
              </p>

              {/* Action Buttons */}
              <div className='flex justify-center mt-4'>
                <button
                  onClick={() => (window.location.href = 'tel:9827504751')}
                  className='bg-green-500 hover:bg-green-600 text-black font-bold py-2 px-4 rounded-l-full'
                  aria-label='Call now'
                >
                  <FaPhone className='inline mr-2 text-red-500' />{' '}
                  {language === 'hindi' ? 'कॉल करें' : 'Call'}
                </button>
                <button
                  onClick={() => {
                    setFormData({
                      ...formData,
                      servicename: service.title[language]
                    })
                    setSelectedOption('message')
                    openModal()
                  }}
                  className='bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded-r-full'
                  aria-label='Message now'
                >
                  <FaEnvelope className='inline mr-2' />{' '}
                  {language === 'hindi' ? 'संदेश भेजें' : 'Send Message'}
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Dark Theme Modal */}
      <Modal
        isOpen={isModalOpen}
        onRequestClose={closeModal}
        className="fixed inset-0 flex items-center justify-center bg-transparent mt-6"
        overlayClassName="fixed inset-0 bg-black bg-opacity-50 z-50 mt-0" 
      >

      <div className="bg-black text-white p-6 rounded-lg shadow-lg max-w-md w-full relative border mt-14 max-h-screen overflow-y-auto">
          <button
            onClick={closeModal}
            className='absolute top-2 right-2 bg-red-500 hover:bg-red-600 text-white font-bold py-1 px-3 rounded-full'
          >
            X
          </button>
          <h2 className='text-xl font-bold mb-4 text-center border-b-2'>
            {language === 'hindi' ? 'संदेश भेजें' : 'Send Message'}
          </h2>
          {errorMessage && (
  <p className="text-red-500 text-center border border-red-500 p-2 rounded-md mb-3">
    {errorMessage}
  </p>
)}

          <input
            type='text'
            name='servicename'
            value={formData.servicename}
            readOnly
            className='w-full p-2 mb-2 bg-gray-800 border border-gray-700 rounded text-white cursor-not-allowed'
          />
          <input
            type='text'
            name='name'
            placeholder={
              language === 'hindi' ? 'अपना नाम लिखे' : 'Write Your Full Name'
            }
            onChange={handleInputChange}
            required
            className='w-full p-2 mb-2 bg-gray-800 border border-gray-700 rounded text-white'
          />
          <input
            type='text'
            name='mobile'
            placeholder={
              language === 'hindi'
                ? 'अपना फ़ोन नंबर लिखे'
                : 'Write Your Mobile No.'
            }
            onChange={handleInputChange}
            required
            className='w-full p-2 mb-2 bg-gray-800 border border-gray-700 rounded text-white'
          />
          {language === 'hindi'
            ? 'अपनी जन्मतारिख चूने :'
            : 'Select Your Birth-Date :'}
          <input
            type='date'
            name='dob'
            onChange={handleInputChange}
            required
            className='w-full p-2 mb-2 bg-gray-800 border border-gray-700 rounded text-white'
          />
          <input
            type='text'
            name='birthplace'
            placeholder={
              language === 'hindi'
                ? 'अपना जन्मस्थान लिखे'
                : 'Enter Your Birth-Place'
            }
            onChange={handleInputChange}
            required
            className='w-full p-2 mb-2 bg-gray-800 border border-gray-700 rounded text-white'
          />
          {/* Gender Selection */}
          <div className='w-full p-2 mb-2 bg-gray-800 border-gray-700 rounded text-white'>
            <label className='block text-sm mb-2'>
              {language === 'hindi' ? 'लिंग चुनें:' : 'Select Gender:'}
            </label>
            <div className='flex gap-4'>
              <label className='flex items-center'>
                <input
                  type='radio'
                  name='gender'
                  value='Male'
                  onChange={handleInputChange}
                  required
                  className='mr-2'
                />
                {language === 'hindi' ? 'पुरुष' : 'Male'}
              </label>
              <label className='flex items-center'>
                <input
                  type='radio'
                  name='gender'
                  value='Female'
                  onChange={handleInputChange}
                  required
                  className='mr-2'
                />
                {language === 'hindi' ? 'महिला' : 'Female'}
              </label>
              <label className='flex items-center'>
                <input
                  type='radio'
                  name='gender'
                  value='Other'
                  onChange={handleInputChange}
                  required
                  className='mr-2'
                />
                {language === 'hindi' ? 'अन्य' : 'Other'}
              </label>
            </div>
          </div>
          <textarea
            name='query'
            placeholder={
              language === 'hindi'
                ? 'अपनी समस्या लिखे..'
                : 'Write Your Query Here...'
            }
            onChange={handleInputChange}
            required
            className='w-full p-2 mb-2 bg-gray-800 border border-gray-700 rounded text-white'
          ></textarea>
          <button
            onClick={sendMessage}
            className='w-full bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded-full'
          >
            {language === 'hindi' ? 'भेजें' : 'Send'}
          </button>
        </div>
      </Modal>
    </div>
  )
}
